const $$splitComponentImporter = () => import('/home/runner/work/zngly-corporate/zngly-corporate/wp-content/themes/zngly-corporate/frontend/src/routes/auth/sso/login.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { requireNonLoggedInUser } from '@/Router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { toast } from 'react-toastify';
import { z } from 'zod';
const searchSchema = z.object({
  code: z.string().optional().nullable().default(null),
  state: z.object({
    type: z.enum(['AZURE_SINGLE_TENANT', 'GOOGLE_MULTI_TENANT']),
    redirectUrl: z.string()
  })
});
export const Route = createFileRoute('/auth/sso/login')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr),
  validateSearch: zodValidator(searchSchema),
  onError() {
    toast.error('Invalid request');
    throw redirect({
      to: '/auth/login'
    });
  },
  beforeLoad() {
    requireNonLoggedInUser();
  }
});